import { viewStorage, domStorage } from '../_globals'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin(ScrollTrigger, SplitText)

export const pageIntro = (delay = 0.5) => {
  const { body } = domStorage
  const { current } = viewStorage

  const pageHeader = current.querySelector('.Page__hero, .Homepage__hero, .Page__header')
  const pageTitle = pageHeader.querySelector('h1')
  const pageSubtitle = pageHeader.querySelector('.subtitle > span')
  const pageAnchors = pageHeader.querySelector('.Anchors__nav')
  const pageSections = [...current.children]
  const allSectionsExceptTheFirst = pageSections.slice(1)
  const pageTitleLines = new SplitText(pageTitle, { type: 'lines' })
  const pageTitleLinesC = new SplitText(pageTitle, { type: 'lines', linesClass: '--oh' })

  const tl = gsap
    .timeline({
      delay,
      defaults: { ease: 'power4.out', duration: 0.8 },
      onComplete: () => {
        // Cleaning styles
        allSectionsExceptTheFirst.length && gsap.set(allSectionsExceptTheFirst, { clearProps: 'y,opacity' })
      }
    })
    
    pageSubtitle && tl.fromTo(pageSubtitle, { yPercent: 100 }, { yPercent: 0 }, 0)
    pageTitleLines.lines.length && tl.fromTo(pageTitleLines.lines, { yPercent: 100 }, { yPercent: 0, stagger: 0.1 }, pageSubtitle ? '-=0.7' : 0)
    pageAnchors && tl.fromTo(pageAnchors, { opacity: 0 }, { opacity: 1 }, '-=0.4')
    allSectionsExceptTheFirst.length && tl.from(allSectionsExceptTheFirst, { y: 10, opacity: 0 }, '-=0.4')

  return tl
}
